import { GzBannerWebComponent } from './component/GzBannerWebComponent';

export { GzBannerWebComponent };
